<template>
  <div class="bottom">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-md-4" v-if="contact">
          <div class="contact-item line-right">
            <div class="image">
              <img src="assets/images/item-background/call.png" alt="" />
            </div>
            <div class="title">{{ $t('contact_us') }}</div>
            <p>
              {{ $t('phone') }}: {{ contact.phone }} <br />
              {{ $t('email') }}: {{ contact.shop_email }}
            </p>
          </div>
        </div>
        <div class="col-md-4" v-if="contact">
          <div class="contact-item line-right" data-wow-delay="0.1s">
            <div class="image">
              <img src="assets/images/item-background/address.png" alt="" />
            </div>
            <div class="title">{{ $t('address_here') }}</div>
            <p>
              {{ contact.address }}, {{ contact.city }}, {{ contact.country }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="contact-item" data-wow-delay="0.2s">
            <div class="image">
              <img src="assets/images/item-background/time.png" alt="" />
            </div>
            <div class="title">{{ $t('opening_time') }}</div>
            <p>
              {{ $t('monday') }} - {{ $t('sunday') }} : {{ openHour.open_time_hours_from }} - {{ openHour.open_time_hours_to }} <br />
              {{ $t('delivery') }} : {{ openHour.delivery_time_from }} - {{ openHour.delivery_time_to }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ContactUsComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      contact: {},
      openHour: {}
    };
  },

  mounted() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/setting`)
      .then((response) => {
        this.contact = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });

    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/open-hour`)
      .then((response) => {
        this.openHour = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
